import { isEmpty } from '@sgme/fp';
import type { ColTypeDef, ValueFormatterParams } from 'ag-grid-community';
import { agMultiColumnFilter } from 'components/shared/Blotter/Grid/Hooks/utils';
import { useSPIntl } from 'hooks/useIntl';
import { useIsInternalUser } from 'hooks/useIsInternalUser';
import { useCallback, useMemo } from 'react';

export const useValueFormatter = () => {
  const isInternalUser = useIsInternalUser();
  const { formatMessages } = useSPIntl();

  return useCallback(
    ({ value, colDef, data }: Pick<ValueFormatterParams, 'colDef' | 'value' | 'data'>) => {
      if (isEmpty(value)) {
        return '';
      }

      const productSubType = data.productSubType ? `.${data.productSubType}` : '.undefined';
      const internalOrExternal = isInternalUser ? '.internalUser' : '.externalUser';

      return formatMessages({
        fallbackIds: [
          `blotter.grid${productSubType}.${colDef.field}${internalOrExternal}.${value}`,
          `blotter.grid${productSubType}.${colDef.field}.${value}`,
          `blotter.grid.${colDef.field}${internalOrExternal}.${value}`,
          `blotter.grid.${colDef.field}.${value}`,
        ],
        defaultMessage: value,
      });
    },
    [formatMessages, isInternalUser],
  );
};
export function useClientSideStringColumnType<T>(handleValuesUpdate: boolean = false): ColTypeDef<T> {
  const valueFormatter = useValueFormatter();
  return useMemo(
    () => ({
      valueFormatter,
      ...agMultiColumnFilter(handleValuesUpdate),
    }),
    [handleValuesUpdate, valueFormatter],
  );
}

export function useServerSideStringColumnType<T>(): ColTypeDef<T> {
  const valueFormatter = useValueFormatter();
  return useMemo(
    () => ({
      valueFormatter,
    }),
    [valueFormatter],
  );
}
